import React from 'react';

const values = [
    ['A', 'AMANAH', 'Memegang teguh kepercayaan yang diberikan'],
    ['K', 'KOMPETEN', 'Terus belajar dan mengembangkan kapabilitas'],
    ['H', 'HARMONIS', 'Saling peduli dan menghargai perbedaan'],
    ['L', 'LOYAL', 'Berdedikasi dan mengutamakan kepentingan bangsa dan negara'],
    ['A', 'ADAPTIF', 'Terus berinovasi dan antusias dalam menggerakan ataupun menghadapi perubahan'],
    ['K', 'KOLABORATIF', 'Membangun Kerjasama yang sinergis'],
];

const missions = [
    'Menyediakan layanan konektivitas yang berkualitas.',
    'Menjadi model pengelolaan operator jaringan.',
    'Pemanfaatan jaringan telekomunikasi secara nasional dalam rangka percepatan ekonomi berbasis digital.',
];

const VisiMisi = () => (
    <div className="py-4 lg:py-6">
        <div className="grid gap-5 lg:grid-cols-2">
            <section className="relative overflow-hidden rounded-[28px] bg-gradient-to-br from-[#005da2] to-[#0a3155] p-7 text-white shadow-[0_22px_55px_rgba(0,93,162,0.20)] sm:p-9">
                <div className="absolute -right-16 -top-16 h-48 w-48 rounded-full border-[28px] border-white/[0.06]" />
                <span className="text-xs font-semibold uppercase tracking-[0.24em] text-blue-200">Visi</span>
                <h2 className="relative mt-6 text-3xl font-bold leading-tight sm:text-4xl">Menjadi Penyelenggara Telekomunikasi Nasional Berbasis Backbone.</h2>
            </section>

            <section className="rounded-[28px] border border-slate-200 bg-white p-7 shadow-[0_20px_50px_rgba(15,23,42,0.07)] sm:p-9">
                <span className="text-xs font-semibold uppercase tracking-[0.24em] text-blue-600">Misi</span>
                <div className="mt-5 space-y-4">
                    {missions.map((mission, index) => (
                        <div key={mission} className="flex gap-4 rounded-2xl bg-slate-50 p-4">
                            <span className="flex h-8 w-8 flex-none items-center justify-center rounded-xl bg-slate-950 text-xs font-bold text-white">0{index + 1}</span>
                            <p className="text-sm leading-6 text-slate-600 sm:text-base">{mission}</p>
                        </div>
                    ))}
                </div>
            </section>
        </div>

        <section className="mt-7 rounded-[30px] border border-slate-200 bg-white p-6 shadow-[0_20px_55px_rgba(15,23,42,0.07)] sm:p-8 lg:p-10">
            <div className="mb-7">
                <span className="text-xs font-semibold uppercase tracking-[0.24em] text-blue-600">Budaya BUMN</span>
                <h2 className="mt-2 text-3xl font-bold tracking-tight text-slate-950">Nilai Perusahaan AKHLAK</h2>
            </div>
            <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
                {values.map(([letter, heading, text], index) => (
                    <article key={`${heading}-${index}`} className="group rounded-2xl border border-slate-200 bg-slate-50 p-5 transition hover:-translate-y-0.5 hover:border-blue-200 hover:bg-blue-50/40">
                        <div className="flex items-center gap-3">
                            <span className="flex h-10 w-10 flex-none items-center justify-center rounded-xl bg-slate-950 text-lg font-bold text-white group-hover:bg-blue-600">{letter}</span>
                            <h3 className="font-bold text-slate-950">{heading}</h3>
                        </div>
                        <p className="mt-3 text-sm leading-6 text-slate-600">{text}</p>
                    </article>
                ))}
            </div>
        </section>
    </div>
);

export default VisiMisi;
